// Minimum support for IE 11 (and nothing earlier)
// This must be the first line in src/index.tsx:
// https://github.com/facebook/create-react-app/tree/master/packages/react-app-polyfill
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "core-js/stable";
import "regenerator-runtime/runtime";
import { hijackEffects } from "stop-runaway-react-effects";

// used by react-datetime-picker
import { shouldPolyfill as shouldPolyfillIntlDatetimeformat } from "@formatjs/intl-datetimeformat/should-polyfill";
import { shouldPolyfill as shouldPolyfillIntlLocale } from "@formatjs/intl-locale/should-polyfill";

async function polyfill(locale: string) {
  if (shouldPolyfillIntlLocale()) {
    await import("@formatjs/intl-locale/polyfill");
  }

  const unsupportedLocale = shouldPolyfillIntlDatetimeformat(locale);
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import("@formatjs/intl-datetimeformat/polyfill-force");

  // Parallelize CLDR data loading
  const dataPolyfills = [
    import("@formatjs/intl-datetimeformat/add-all-tz"),
    import(`@formatjs/intl-datetimeformat/locale-data/${unsupportedLocale}`),
  ];
  await Promise.all(dataPolyfills);
}
const userLocale = navigator.language || "en-US"; // default to 'en-US' if navigator.language is not available
polyfill(userLocale);

// -- stop runaway useEffect loops with a loop rate limiter --
// default is 60 calls max in 1 second
// but group tiles pages with many processes (e.g. KK) will throw the runaway warning (develop only)
// 120 seems to be the minimum for KK
// when zooming into timeline component e.g. hublet page https://localhost:3000/raveng/dashboard/All/9 we can go as high at ~250/s
// so setting limit to 300
if (process.env.NODE_ENV === "development") {
  hijackEffects({ callCount: 300, timeLimit: 1000 });
}

// polyfill String.replaceAll
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    return this?.replace(new RegExp(search, "g"), replacement);
  };
}
